export interface CabinClass {
    code: string;
    title: string;
}

export const cabinClasses = [
    {
        code: 'P',
        title: 'اکونومی پلاس',
    },
    {
        code: 'Y',
        title: 'اکونومی کلاس',
    },
    {
        code: 'C',
        title: 'بیزینس کلاس',
    },
];
